// What the settings pages share: the error words and the address open switch.
import { ApiError } from "../../api/client";
import { useSession } from "../../app/session";

export const errorText = (e: unknown) => (e instanceof ApiError ? e.message : "That didn't save. Try again.");

/** Head office sets a company's web address: an owner above it, or the top company for itself (the server checks too). */
export function useAddressOpen(): boolean {
  const { company, companies } = useSession();
  if (!company.parentId) return company.role === "owner";
  for (let up: string | null = company.parentId; up;) {
    const above = companies.find((c) => c.id === up);
    if (!above) break;
    if (above.role === "owner") return true;
    up = above.parentId;
  }
  return false;
}
